module.exports = __webpack_public_path__ + "media/images/hero/glyph-2-7b45896314fca2890a073021904ef6d3.svg";